import { indexData } from '@/mocks/home';

export default function SectionIndex() {
  return (
    <section
      id="index"
      className="py-16 md:py-20 bg-background-50"
    >
      <div className="max-w-[1920px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="text-center mb-8 md:mb-10">
          <span className="inline-block text-xs font-medium text-primary-500 bg-primary-500/10 px-3 py-1 rounded-full mb-3">
            分类导航
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
            专题合集
          </h2>
          <p className="text-sm text-foreground-400 mt-2">按类型快速找到你想看的影片</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {indexData.map((item) => (
            <a
              key={item.title}
              href="#cards"
              className="group flex flex-col items-center text-center p-5 md:p-6 bg-background-100 rounded-xl border border-background-300/40 hover:border-primary-500/40 hover:bg-background-200/70 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-primary-500/10 flex items-center justify-center mb-3 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${item.icon} text-primary-500 text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-100 whitespace-nowrap">
                {item.title}
              </h3>
              <span className="text-xs text-primary-500 font-medium mt-1">{item.count}</span>
              <p className="text-[11px] md:text-xs text-foreground-500 mt-1.5 hidden sm:block">
                {item.desc}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}